import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function MentionsLegales() {
  const { t } = useLanguage();
  const sections = t("legal.sections");

  return (
    <div data-testid="mentions-legales-page" className="min-h-screen bg-paper text-ink">
      <header className="border-b border-ink/5 bg-paper/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-ink/60 hover:text-ink transition-colors duration-300">
            <ArrowLeft size={14} /> {t("legal.back")}
          </Link>
          <span className="font-serif text-lg">Oléna <span className="text-brass">Gurova</span>-Vacher</span>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}
          className="text-[11px] uppercase tracking-[0.35em] text-brass mb-6">
          {t("legal.eyebrow")}
        </motion.p>
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
          className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-16">
          {t("legal.title")}
        </motion.h1>
        <div className="space-y-14">
          {sections.map((s, i) => (
            <motion.section
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              data-testid={`legal-section-${i}`}
              className="border-t border-ink/10 pt-10"
            >
              <h2 className="font-serif text-2xl mb-5">{s.title}</h2>
              {s.body.map((p, j) => (
                <p key={j} className="text-sm leading-relaxed text-ink/70 mb-3 max-w-3xl">{p}</p>
              ))}
            </motion.section>
          ))}
        </div>
      </main>
    </div>
  );
}
